import React from 'react'

export const Header = (): JSX.Element => {
  return <div>apple</div>
}
